import axios from "axios";
import qs from "qs";
import getCookie from "@/utils/auth";

export default axios.create({
    baseURL: "http://127.0.0.1:8000/satmeta/api/v2/",
    timeout: 5000,
    headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS"
    },
});

axios.defaults.paramsSerializer = params => {
    return qs.stringify(params, { arrayFormat: "repeat" });
};

// 请求拦截器
axios.interceptors.request.use(
  config => {
    const vsatAuth = getCookie('vsat-auth'); // 从本地浏览器的cookie获取vsat-auth的值
    
    if (vsatAuth) {
      config.headers['VSAT-AUTH'] = vsatAuth; // 写入VSAT-AUTH这个自定义的Header中
    } else {
      window.location.href = 'https://apps.vsat.cloud/'; // 跳转到https://apps.vsat.cloud/
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
// Do something with response data
function processResponse(response) {
    return response.data;
}

// Do something with response error
function processError(error) {
    console.log(error) // for debug
    return Promise.reject(error);
}

if (process.env.NODE_ENV === "development") {
    axios.defaults.baseURL = "http://127.0.0.1:8000/satmeta/api/v2/",
    axios.interceptors.response.use(processResponse, processError);
} else {
    axios.defaults.baseURL = "https://app.vsat.cloud/satmetapi/v2c/";
    axios.interceptors.response.use(processResponse, processError);
}

export * from "./organization";
export * from "./satellite";
export * from "./data-vendor";
export * from "./operational-status";
export * from "./dashboard";
export * from "./instrument";
export * from "./mission";
export * from "./appcenter";
